module.exports = __webpack_public_path__ + "static/media/lk.05027eb4.svg";